"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _TruncatedTextWithTooltip = require("./TruncatedTextWithTooltip");
Object.keys(_TruncatedTextWithTooltip).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TruncatedTextWithTooltip[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TruncatedTextWithTooltip[key];
    }
  });
});